import cx from 'classnames'

import Styles from './Properties.module.scss'

import { PropertyForm } from 'common/PropertyForm/PropertyForm'
import { ChangeVisibilityButton } from './ChangeVisibilityButton'
import { EditableProperty } from './Properties'
import { PropertyType } from 'api/clients/PropertyClient'

type Props = {
  editableProperty: EditableProperty
  onClose: () => void
}

export const EditDefaultProperty = ({ editableProperty, onClose }: Props) => {
  const { property } = editableProperty

  return (
    <>
      <PropertyForm
        variant="large"
        property={property}
        type={property.type}
        propertyTypes={[]}
        disabled={true}
        forceShowNameInput={true}
      />
      <div className={cx(Styles.mdText, Styles.marginBottom8)}>This property can not be edited or removed.</div>
      {property.type === PropertyType.Title || property.name === 'Posts' ? (
        ''
      ) : (
        <>
          <div className={cx(Styles.divider, Styles.margintop16)}></div>
          <ChangeVisibilityButton editableProperty={editableProperty} onClose={onClose} />
        </>
      )}
    </>
  )
}
